<template>
<body>
  <div class="modalContainer active loginModal formsModal">
    <div class="actualModal">
      <a href="#" class="closeModal"><i class="fal fa-times"></i></a>
      <form @submit.prevent="handleSubmit" class="modalBodyOfItem">
        <div class="itemBodyLeftModal">
          <h4>Account Setup/Payment</h4>
          <div class="inputsContainer">
            <div class="individualInput">
              <h5>Full Name</h5>
              <input v-model="name" type="text" name="" id="" placeholder="John Doe" />
            </div>
            <div class="individualInput">
              <h5>Credit Card Number</h5>
              <input maxlength="16" v-model="number" min="1000000000000000" max="9999999999999999" type="number" name="" id="" placeholder="Enter Card Number" />
            </div>
            <div class="dualInputContainer">
              <div class="individualInput">
                <h5>Expiration Date</h5>
                <input maxlength="5" v-model="expdate" type="text" name="" id="" placeholder="01/21" />
              </div>
              <div class="individualInput">
                <h5>Security Code</h5>
                <input maxlength="4" v-model="code" min="0" max="999" type="number" name="" id="" placeholder="921" />
              </div>
            </div>
          </div>
          <div class="mobileFlex"></div>

          <div class="quickCheckout">
            <div style="margin-bottom: 5px;" v-if="haserrors" class="error">Please make sure you've
              entered a valid card and try again.</div>
            <button type="submit">Complete</button>
            <br />
            <a @click="goShop" href="#">Add Later</a>
          </div>
          <div class="formProgress">
            <p>3/3</p>
          </div>
        </div>
      </form>
    </div>
  </div>
</body>

</html>
</template>
<script>
import config from '@/config'
var stripe = Stripe(config.stripeKey)
import validator from 'validator'
import {
  setupService
} from '@/services/setup'
import creditCardType from 'credit-card-type'
export default {
  name: 'SignUp',
  created() {
    this.$store.dispatch('auth/fetchUser')
  },
  computed: {
    cardType() {
      if (!this.number) return null
      let numString = this.number.toString()
      let cards = creditCardType(numString)
      if (cards && cards[0].type) return cards[0].type
      return cards
    },
    zip() {
      return this.$store.state.setup.address.zip
    },
    month() {
      if (!this.expdate) return
      let split = this.expdate.split('/')
      return split[0]

    },
    year() {
      if (!this.expdate) return
      let split = this.expdate.split('/')
      let year = split[1]
      /*let yearString = year.toString()
      console.log(yearString, yearString.length)
      if (yearString.length != 2 && yearString.length != 4) {
        console.log('invalid year')
        return null
      } */
      return year

    }
  },
  data() {
    return {
      haserrors: false,
      name: '',
      email: '',
      password: '',
      expdate: null,
      number: null,
      code: null,
      token: this.$route.query.token
    }
  },
  methods: {
    goShop() {
      this.$router.push('/signupcomplete')
    },
    async createToken() {
      let cardData = {
        card: {
          name: this.name,
          number: this.number,
          exp_month: this.month,
          exp_year: this.year,
          cvc: this.code,
          address_zip: this.zip
        },
      }
      // console.log(`creating stripe token with data`, cardData)
      let token = await setupService.getStripeToken(cardData)
      // console.log(`got token`, token)
      return token
    },
    validateForm() {
      let {number,code,year,month,name} = this
      let validNumber = validator.isCreditCard(number)
      let codeStr = code.toString()
      // console.log(codeStr,validNumber,month,year,name)
      if(codeStr.length != 3 && codeStr.length != 4) return false
      // consolle.log(codeStr,validNumber)
      if(!year || !month || !code || !name || !validNumber) return false
      return true
    },
    async handleSubmit(e) {
      console.log('form submitted')
      // this.haserrors = false
      let {
        month,
        year,
        number,
        code,
        name,
        cardType
      } = this
      // console.log(month, year, number, code, name, cardType)
      let validated = this.validateForm()
      if (!month || !year || !number || !code || !name || !cardType || !validated) {
        this.haserrors = true
        return console.error('form incomplete')
      }
      let card = {
        month,
        year,
        number,
        code,
        name,
        cardType
      }
      console.log(`creating stripe card token`)
      try {
        let token = await this.createToken()
        if (token && token.id) {
          console.log(`created stripe token!`, token)
          let payload = {
            card,
            token: token.id
          }
          console.log(`dispatching to step3`)
          this.$store.dispatch('setup/step3', payload)
        }
      } catch (e) {
        console.error(e)
        this.haserrors = true
      }

    }
  }
}
</script>
<style>
.sign-up-page-wrapper {
  padding: 5px;
}

.error {
  color: red;
}
</style>
